import { Box } from "@chakra-ui/react";
import { useColorModeValue } from "@/components/ui/color-mode-utils";
import toast from "react-hot-toast";
import { Close } from '@/assets/icons';
import NotificationUnread from '@/assets/icons/NotificationUnread';
import Show from '@/components/Molecules/Show';
import NotificationRead from '@/assets/icons/NotificationRead';
import { NotificationItem } from "@/services/notifications";
import NotificationCheck from '@/assets/icons/NotificationCheck';

interface PendingNotificationProps {
  onClick: (notificationId: string) => void;
  item: NotificationItem;
  toastId: string;
  mt?: number;
}

const PendingNotification = ({ onClick, item, toastId, mt = 1 }: PendingNotificationProps) => {

  const textColor = useColorModeValue('gray.800', 'gray.100');

  return (
    <Box
      key={item.notificationId}
      width={400}
      p={1}
      pr={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      bg={{ base: 'white', _dark: 'gray.800' }}
      color={{ base: textColor, _dark: 'white' }}
      _hover={{
        bg: 'brand.solidGradient',
        color: 'white',
        cursor: 'pointer',
        '& > div > div': { color: 'white' },
        '& svg': { color: 'white' },
      }}
      onClick={() => {
        toast.dismiss(toastId);
        onClick(item.notificationId);
      }}
      borderRadius={10}
      gap={2}
      boxShadow="sm"
      border="1px solid"
      borderColor={{ base: 'gray.300', _dark: 'gray.600' }}
      mt={mt}
      minH={14}
      shadow={{ _dark: 'xs', _light: 'sm' }}
      position="relative"
    >
      <Box
        position="absolute"
        top="-8px"
        right="-8px"
        onClick={(e) => {
          e.stopPropagation();
          toast.dismiss(toastId);
        }}
        cursor="pointer"
        p={1.5}
        borderRadius="full"
        bg="gray.200"
        _hover={{
          bg: { base: 'gray.200', _dark: 'gray.300' },
        }}
        zIndex={1}
      >
        <Close height={8} width={8} />
      </Box>

      <Box display="flex" alignItems="center" flex="1">
        <Box display="flex" alignItems="center">
          <NotificationCheck height={30} width={35} />
        </Box>
        <Box display="flex" flexDirection="column" gap={0.5}>
          <Box
            fontSize="xs"
            fontWeight={!item.isRead ? 600 : 400}
            whiteSpace="normal"
            wordBreak="break-word"
          >
            {item.body.length > 90 ? `${item.body.slice(0, 90)}...` : item.body}
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Show when={!item.isRead}>
          <NotificationRead height={35} width={45} />
        </Show>
        <Show when={item.isRead}>
          <NotificationUnread height={35} width={45} />
        </Show>
      </Box>
    </Box>
  )
}

export default PendingNotification;